export function currencyConversion(amount: number, conversionRate: number, isConversionReversed = false): number {
    if (isConversionReversed) {
        return +(amount * (1 / conversionRate)).toFixed(2);
    }

    return +(amount * conversionRate).toFixed(2);
}
